import React, { Component } from 'react';
import * as Scroll from 'react-scroll';
import RefinePVLSearchForm from './refinePVLSearchForm';
import RefineCVLSearchForm from './refineCVLSearchForm';
import Axios from 'axios';
import ErrorBlock from './errorBlock';
import SelectInput from './selectInput';
import { translate } from 'react-i18next';
import ReactGA from 'react-ga';
import { parse } from 'qs';
import { withRouter } from 'react-router-dom';
import store from '../store';
import { storeReg, storeEnvUrl, storeEnvToken } from '../actions';

class SearchTabs extends Component {
  state = {
    selectedTabId: null,
    error: false,
    updated: false,
    search: '',
    vrm: '',
  };

  ref = React.createRef();

  componentDidMount() {
    const { t, location } = this.props;
    const query = parse(location.search, { ignoreQueryPrefix: true });
    const tokenKey = query.distributor !== undefined ? '_DISTRIBUTOR_TOKEN' : '_TOKEN';
    const url =
      process.env.REACT_APP_ENV === 'production' ? t('config.PROD_URL') : t('config.STAGING_URL');

    const token =
      process.env.REACT_APP_ENV === 'production'
        ? t(`config.PROD${tokenKey}`)
        : t(`config.STAGING${tokenKey}`);
    const initialActiveTab = t('config.show_vrm') ? 'registration' : 'search';

    store.dispatch(storeEnvUrl(url));
    store.dispatch(storeEnvToken(token));

    this.getGroups();

    if (this.props.isSearchOnly) {
      this.setState({ type: '' });
      this.getTypeOptions();
    }

    this.setActiveTab(initialActiveTab);
  }

  componentDidUpdate(prevProps) {
    const { searchOnly, selectedFamily } = this.props;

    if (prevProps.selectedFamily !== selectedFamily) {
      this.setState({
        updated: false,
        error: false,
        vrmSearchManufacturer: null,
        vrmSearchResults: null,
      });

      if (searchOnly) {
        this.setState({
          type: '',
        });
        this.getTypeOptions();
      }
    }
  }

  setLob = (i18n) => ['is', 'fr-be', 'nl-be'].indexOf(i18n.language) > -1;

  isActive = (id) => {
    return this.state.selectedTabId === id;
  };

  setActiveTab = (selectedTabId) => {
    this.setState({
      selectedTabId,
      updated: false,
      error: false,
      vrmSearchManufacturer: null,
      vrmSearchResults: null,
    });

    if (this.ref && this.state.selectedTabId) {
      Scroll.animateScroll.scrollTo(this.ref.offsetTop, { duration: 250 });
    }
  };

  equipment = (data) => {
    this.props.equipment({ equipment: data });
  };

  handleTypeChange = (value) => {
    this.setState({
      type: value,
      updated: false,
      error: false,
    });
  };

  // Get family groups
  // needs to be done first before any proceeding api calls (except for VRM search)
  getGroups = () => {
    const { i18n, t } = this.props;
    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const params = { culture: t('config.CULTURE') };

    params.lob = 'b2b';

    if (this.setLob(i18n)) {
      params.lob = 'b2c';
    }

    Axios.get(url + '/api/browse', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        this.setState({
          groups: response.data.family_groups,
        });
      })
      .catch((error) => {
        this.setState({ error: t('search_tabs.error') });
        console.warn(error);
      });
  };

  // For CVL dropdown
  getTypeOptions = () => {
    const { i18n, t, selectedFamily } = this.props;
    const url = store.getState().content.url;
    const token = store.getState().content.token;

    const params = {
      culture: t('config.CULTURE'),
      group: selectedFamily,
    };

    params.lob = 'b2b';

    if (this.setLob(i18n)) {
      params.lob = 'b2c';
    }

    Axios.get(url + '/api/oem/family', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        const arr = [];

        response.data.families.forEach((element) => {
          // exclude vans
          if (selectedFamily === 'commercial' && element.key.includes('vans')) return;

          let options = {
            value: element.val,
            label: element.val,
            key: element.key,
          };

          arr.push(options);
        });

        this.setState({ typeOptions: arr });
      })
      .catch((error) => {
        this.setState({ error: t('search_tabs.error') });
        console.warn(error);
      });
  };

  handleVRMSubmit = (e) => {
    e.preventDefault();
    const { i18n, t, selectedFamily } = this.props;
    const { groups } = this.state;
    const familyGroup = groups.find((group) => group.key === selectedFamily).val || '';
    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const searchTerms = this.refs.searchTerm.value;
    const params = {
      culture: t('config.CULTURE'),
      vrm: searchTerms,
    };

    params.lob = 'b2b';

    if (this.setLob(i18n)) {
      params.lob = 'b2c';
    }

    this.setState({
      updated: false,
      vrmSearchManufacturer: null,
      vrmSearchResults: null,
      showVRMLoader: true,
    });

    Axios.get(url + t('config.VRM_END_POINT'), {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        if (response.data.model.length === 1) {
          store.dispatch(storeReg(searchTerms));

          this.equipment({
            value: response.data.model[0].display_name_long,
            label: response.data.model[0].display_name_long,
            key: response.data.model[0].equipment,
          });
        } else if (response.data.model.length > 1) {
          const results = [];

          store.dispatch(storeReg(searchTerms));

          response.data.model.forEach((model) => {
            results.push({
              value: model.display_name_long,
              label: model.display_name_long,
              key: model.equipment,
            });
          });

          this.setState({
            vrmSearchManufacturer: response.data.model[0].manufacturer,
            vrmSearchResults: results,
          });
        } else {
          this.getPVLData().then((results) => {
            this.setPVLData(results, familyGroup);
          });

          this.setState({ error: t('search_tabs.no_results') });
        }

        this.setState({ showVRMLoader: false });
      })
      .catch((error) => {
        this.getPVLData().then((results) => {
          this.setPVLData(results, familyGroup);
        });

        this.setState({
          showVRMLoader: false,
          error: t('search_tabs.no_results'),
        });

        console.warn(error);
      });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { i18n, t, searchOnly, selectedFamily } = this.props;
    const { groups, type } = this.state;
    
    
    
    const familyGroup = groups.find((group) => group.key === selectedFamily) ? groups.find((group) => group.key === selectedFamily).val : '';
    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const searchTerms = this.refs.searchTerm.value;

    this.setState({ familyGroup, error: false, updated: false });
    store.dispatch(storeReg(''));

    //family is now
    //PVL - Cars or Vans - vtype 1
    //CVL - Sub selection from type dropdown - vtype 2
    const params = {
      culture: t('config.CULTURE'),
      vtype: searchOnly ? '2' : '1',
      facets: {
        familygroup: familyGroup,
      },
      text: searchTerms,
    };

    params.lob = 'b2b';

    if (this.setLob(i18n)) {
      params.lob = 'b2c';
    }

    if (searchOnly) {
      params.facets.family = type.value;
    }

    Axios.get(url + '/api/search', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        if (response.data.model.length > 0) {
          //show the error message if the search term is empty
          if (searchTerms === '') {
            this.setState({ error: t('search_tabs.no_results') });
          }
          //if we are on CVL we need to filter the results first.
          if (searchOnly) {
            this.setCVLData(response.data, searchTerms);
          } else {
            this.setPVLData(response.data, searchTerms);
          }
        } else {
          this.setState({ error: t('search_tabs.no_results') });
        }
      })
      .catch((error) => {
        this.setState({ error: t('search_tabs.error') });
        console.warn(error);
      });
  };

  /**
   * Get CVL manufacturers if nothing comes back from the initial search
   */
  getCVLData = () => {
    const { i18n, t, selectedFamily } = this.props;
    const { groups, type } = this.state;
    const familyGroup = groups.find((group) => group.key === selectedFamily).val || '';
    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const params = {
      culture: t('config.CULTURE'),
      vtype: '2',
      text: `${familyGroup} ${type.value}`,
      facets: {
        familygroup: familyGroup,
        family: type.value,
      },
    };

    params.lob = 'b2b';

    if (this.setLob(i18n)) {
      params.lob = 'b2c';
    }

    return Axios.get(url + '/api/search', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.setState({ error: t('generic_labels.error') });
        console.warn(error);
      });
  };

  setCVLData = (results, searchTerms) => {
    const { groups, type } = this.state;

    this.setState({
      CVLData: {
        results,
        searchTerms,
        groups,
        type,
      },
      updated: true,
    });
  };

  /**
   * Get PVL manufacturers if nothing comes back from the initial search
   */
  getPVLData = () => {
    const { i18n, t, selectedFamily } = this.props;
    const { groups } = this.state;
    const familyGroup = groups.find((group) => group.key === selectedFamily).val || '';
    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const params = {
      culture: t('config.CULTURE'),
      vtype: '1',
      text: familyGroup,
      facets: { familygroup: familyGroup },
    };

    params.lob = 'b2b';

    if (this.setLob(i18n)) {
      params.lob = 'b2c';
    }

    return Axios.get(url + '/api/search', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        this.setState({ error: t('generic_labels.error') });
        console.warn(error);
      });
  };

  setPVLData = (results, searchTerms) => {
    const { groups } = this.state;

    this.setState({
      PVLData: {
        results,
        searchTerms,
        groups,
      },
      updated: true,
    });
  };

  handleVRMInputChange = (e) => {
    this.setState({ vrm: e.target.value });
  };

  handleSearchInputChange = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { i18n, t, searchOnly, selectedFamily } = this.props;
    const {
      PVLData,
      CVLData,
      typeOptions,
      type,
      updated,
      error,
      groups,
      vrmSearchManufacturer,
      vrmSearchResults,
      showVRMLoader,
    } = this.state;
    const { search, vrm } = this.state;

    const errorBlock = <ErrorBlock error={error} />;

    const loader = (
      <div className="loading-block">
        <img className="loader" src="images/loader2.gif" alt="loader" />
      </div>
    );

    const regContent = (
      <div className="tab-content">
        <div className="reg-content">
          <p>{t('search_tabs.registration_number')}</p>
          <form onSubmit={this.handleVRMSubmit}>
            <input
              type="text"
              ref="searchTerm"
              className="reg-input"
              onChange={this.handleVRMInputChange}
            />

            <button
              className="button"
              disabled={vrm === ''}
              onClick={() =>
                ReactGA.event({
                  category: i18n.language,
                  action: selectedFamily,
                  label: 'Reg Submit',
                })
              }
            >
              {t('search_tabs.submit')}
            </button>
            {t('config.vrm_flag_image') &&
              <span
                className="country-logo"
                style={{
                  backgroundImage: `url(images/${t('config.vrm_flag_image')})`
                }}
              />}
          </form>
          {errorBlock}
        </div>
      </div>
    );

    const searchContent = (
      <div className={'tab-content ' + (searchOnly ? 'search-only' : '')}>
        {searchOnly ? <p className="content-title">{t('search_tabs.search')}</p> : ''}
        <div className="search-content">
          <p>{t('search_tabs.vehicle_details')}</p>
          <form onSubmit={this.handleSubmit}>
            <input type="text" ref="searchTerm" onChange={this.handleSearchInputChange} />
            <button
              className="button"
              disabled={search === ''}
              onClick={() =>
                ReactGA.event({
                  category: i18n.language,
                  action: selectedFamily,
                  label: 'Search Submit',
                })
              }
            >
              {t('search_tabs.submit')}
            </button>
          </form>
          {errorBlock}
        </div>
      </div>
    );

    const tabbedContent = (
      <div>
        {t('config.show_vrm') && (
          <div
            className={'registration tab ' + (this.isActive('registration') ? 'active' : '')}
            onClick={() => this.setActiveTab('registration')}
          >
            <p className="registration-tab">{t('search_tabs.enter_reg')}</p>
          </div>
        )}
        <div
          className={'search tab ' + (this.isActive('search') ? 'active' : '')}
          onClick={() => this.setActiveTab('search')}
        >
          <p className="search-tab">{t('search_tabs.search')}</p>
        </div>
        {this.isActive('registration') ? regContent : searchContent}
      </div>
    );

    const refinePVLSearchForm = (
      <RefinePVLSearchForm
        key={selectedFamily}
        data={PVLData}
        selectedFamily={selectedFamily}
        equipment={this.equipment}
      />
    );
    const refineCVLSearchForm = (
      <RefineCVLSearchForm
        key={selectedFamily}
        data={CVLData}
        selectedFamily={selectedFamily}
        equipment={this.equipment}
      />
    );

    const forms = searchOnly && type ? refineCVLSearchForm : refinePVLSearchForm;

    const modelSelector = (
      <div className="model-select">
        <p className="select-vehicle-model">{t('search_tabs.select_model')}</p>
        <p className="vrm-manufacturer">{`${t(
          'vehicle_spec.manufacturer',
        )} ${vrmSearchManufacturer}`}</p>
        <SelectInput
          key={selectedFamily}
          handleChange={this.equipment}
          options={vrmSearchResults}
          value="model"
        />
      </div>
    );

    return groups ? (
      <div>
        <section className="search-tabs" ref={(node) => (this.ref = node)}>
          {searchOnly && typeOptions ? (
            <div className="type-select">
              <p className="select-vehicle-type">{t('search_tabs.vehicle_type')}</p>
              <SelectInput
                key={selectedFamily}
                handleChange={this.handleTypeChange}
                options={typeOptions}
                value="type"
              />
            </div>
          ) : (
              ''
            )}
          {searchOnly && type ? searchContent : ''}
          {!searchOnly ? tabbedContent : ''}
          {showVRMLoader && loader}
          {!searchOnly && vrmSearchResults && modelSelector}
        </section>
        {updated ? forms : ''}
      </div>
    ) : (
        loader
      );
  }
}

export default withRouter(translate('translations')(SearchTabs));



// WEBPACK FOOTER //
// ./src/components/searchTabs.js